// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TzYV","colBig":"styles_colBig__Fw6eh","colSmall":"styles_colSmall__IkSQ4","shopifyNameWrapper":"styles_shopifyNameWrapper__2gkD3"};